import ActionTypes from "../constants/action_types";

export default function clearDocumentTypes() {
  return {
    type: ActionTypes.SEARCH_CLEAR.SUCCESS,
  };
}
